import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
var Root = styled(Text).withConfig({
  displayName: "DrawerTitle__Root",
  componentId: "sc-19dmtak-0"
})(["flex:1;margin:0;"]);

var DrawerTitle = function DrawerTitle(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return (
    /*#__PURE__*/
    React.createElement(Root, _extends({
      forwardedAs: "h4",
      token: Text.tokens.TEXT_LG_BOLD
    }, rest), children)
  );
};

DrawerTitle.defaultProps = {
  children: undefined
};
process.env.NODE_ENV !== "production" ? DrawerTitle.propTypes = {
  /**
   * The text for the title
   */
  children: PropTypes.node
} : void 0;
export default DrawerTitle;